import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LookupDTO } from '../models/lookup.model';

@Injectable({
  providedIn: 'root'
})

export class GenericTableService {

  constructor(private http: HttpClient) {
  }

  getLookupGenericTable(): Promise<Array<LookupDTO>> {
    return this.http.get<Array<LookupDTO>>(environment.apiFullUrl + '/GenericTable/GetLookupGenericTable' + "?ClientID=E1846FBA-641B-4663-973C-6CED1D778EF9").toPromise();
  }

  GetLookupGenericTableGroup(GroupName: string): Promise<Array<LookupDTO>> {
    return this.http.get<Array<LookupDTO>>(environment.apiFullUrl + '/GenericTable/GetLookupGenericTableGroup/' + GroupName).toPromise();
  }
}
